<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <PoiForm :basePoi="poi" :basepoiName="name" :loading="loading" @submit-requested="submitRequested" :poiType="this.$route.query.type"></PoiForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import PoiForm from './PoiForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                poi: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { PoiForm },
        computed:
        {
            ...mapState('pois', ['getPoiByIdOutput']),
        },
        methods: {
            ...mapActions('pois', ['getPoiById']),
            ...mapActions('pois', ['putPoi']),
            submitRequested(poi) {
                this.putPoi(poi);
            },
        },
        mounted: function () {
            if (!this.$route.query.id || !this.$route.query.type) {
                router.push({name: 'Pois'});
            }
            else {
                this.getPoiById(this.$route.query.id);
            }
        },
        watch:
        {
            getPoiByIdOutput: function (output) {
                if (!output) {
                    router.push({name: 'Pois'});
                }
                else {
                    this.poi = output;
                    this.loading = false;
                }
            }
        }
    }
</script>